const THOUSAND = 1_000
const MILLION = 1_000_000
const ENGLISH_NUMBER_FORMAT = 'en-US'

export type JackpotTickerFormatMode = 'default' | 'compactMillions'

function formatNumber(value: number, options?: Intl.NumberFormatOptions) {
  return new Intl.NumberFormat(ENGLISH_NUMBER_FORMAT, options).format(value)
}

function formatDefaultJackpotTickerValue(amount: number, currency: 'GC' | 'SC') {
  const fractionDigits = currency === 'SC' ? 2 : 0

  return formatNumber(amount, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
}

function formatCompactMillionsJackpotTickerValue(amount: number) {
  const absoluteAmount = Math.abs(amount)

  if (absoluteAmount >= MILLION) {
    // Round half up: round to nearest 0.1, 0.5 rounds up (e.g. 1.05 → 1.1, 1.499 → 1.5)
    const amountInMillions = Math.round((amount / MILLION) * 10) / 10

    return `${formatNumber(amountInMillions, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })} M`
  }

  if (absoluteAmount >= THOUSAND) {
    return formatNumber(Math.floor(amount), {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }

  return formatNumber(amount, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function formatJackpotTickerValue(
  amount: number,
  currency: 'GC' | 'SC',
  mode: JackpotTickerFormatMode = 'default',
) {
  if (mode === 'compactMillions') {
    return formatCompactMillionsJackpotTickerValue(amount)
  }

  return formatDefaultJackpotTickerValue(amount, currency)
}
